export const contactFormTrackingIDs = {
    business: {
        id: 'dagligbank-kontakt-form-business',
    },
    private: {
        id: 'dagligbank-kontakt-form-private',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGFjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy91dGlscy9ndG0vdHJhY2tJRHMvY29udGFjdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRztJQUNsQyxRQUFRLEVBQUU7UUFDTixFQUFFLEVBQUUsa0NBQWtDO0tBQ3pDO0lBQ0QsT0FBTyxFQUFFO1FBQ0wsRUFBRSxFQUFFLGlDQUFpQztLQUN4QztDQUNKLENBQUMifQ==